// Copyright (c) StrangeBee 2023

import React, { ReactElement, useMemo } from 'react';
import THTableFooter from '@Molecules/THTableFooter/THTableFooter';
import TaskLogItem from '@Organisms/TaskLog/TaskLogItem/TaskLogItem';
import { UsePaginationReturn } from '@Hooks/usePagination';
import { TaskLogOutput, TaskOutput, TaskStatus } from 'thehive-sdk';
import { TaskLogEventList } from '@Organisms/TaskLog/eventList';
import { TaskEventList } from '@Organisms/Task/eventList';

import './TaskLogList.scss';

interface TaskLogListProps {
    paginationManager: UsePaginationReturn;
    list: TaskLogOutput[];
    count: number;
    eventList: TaskLogEventList;
    hasCortex?: boolean;
    caseId: string;
    taskId: string;
    taskEventList: TaskEventList;
    task?: TaskOutput;
}

const TaskLogList = ({
    paginationManager,
    list,
    count,
    eventList,
    hasCortex = false,
    caseId,
    taskId,
    taskEventList,
    task,
}: TaskLogListProps): ReactElement => {
    const { itemsPerPage, page, setPagination } = paginationManager;

    const disableDeletion: boolean | undefined = useMemo(() => {
        return task?.mandatory && count <= 1 && task?.status === TaskStatus.COMPLETED;
    }, [count, task]);

    const onEditHandler =
        (id: string) =>
        (data: any): Promise<any> => {
            return eventList.onMultiEdit(data, id);
        };

    return (
        <div className="task-logs">
            {list && count !== 0 && (
                <div>
                    {list.map((taskLog) => (
                        <TaskLogItem
                            task={task}
                            taskId={taskId}
                            taskEventList={taskEventList}
                            taskLog={taskLog}
                            key={taskLog._id}
                            deleteTaskLog={eventList.onDelete}
                            editTaskLog={onEditHandler(taskLog._id)}
                            enableResponder={hasCortex}
                            caseId={caseId}
                            disableDeletion={disableDeletion}
                        />
                    ))}
                    <THTableFooter
                        page={page}
                        itemsPerPage={itemsPerPage}
                        total={count}
                        onPageChange={(page): void => setPagination((prevValues) => ({ ...prevValues, page }))}
                    />
                </div>
            )}
        </div>
    );
};

export default TaskLogList;
